import { CompanyId, GoalWithProgress, Role } from '../../services/api.types'
import { IGlobalState } from '../../Root/store/appReducer'
import { getCurrentCompanyGoal, joinGoal, leaveGoal } from '../../views/Activity/store/ActivityActions'
import { connect } from 'react-redux'
import YumChallengeActions, { IYumChallengeTabsDispatchProps, IYumChallengeTabsStateProps } from './YumChallengeActions'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import { deleteGoal } from '../../views/ChallengeAdmin/store/ChallengeAdminActions'
import { getLoadingJoinGoal } from '../../common/loading/loadingSelectors'

interface IOwnProps {
  className?: string
  goal: GoalWithProgress
  isListView?: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumChallengeTabsStateProps => {
  const { goal, isListView, className } = ownProps
  return {
    className,
    goal,
    isListView,
    hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
    joinInProgress: getLoadingJoinGoal(state),
  }
}

const mapDispatchToProps: IYumChallengeTabsDispatchProps = {
  joinGoal,
  leaveGoal,
  deleteGoal,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumChallengeActions)
